import { getAxios } from "./helpers";
import Config from "@vaersaagod/tools/Config";
import Viewport from "@vaersaagod/tools/Viewport";

/**
 * Initialise a Stripe Elements Card on a DOM node
 *
 * @param node
 * @param opts
 * @returns {Promise<unknown>}
 */
export const initCardElement = (node, opts = {}) => new Promise((resolve, reject) => {

    const { id } = node;
    if (!id) {
        reject('Card element node has no ID');
        return;
    }

    const then = new Date().getTime();
    let card = null;

    const setFontsize = () => {
        if (card !== null) {
            if (Viewport.breakpoint.size > 750) {
                card.update({style: {base: {fontSize: '20px'}}});
            } else {
                card.update({style: {base: {fontSize: '16px'}}});
            }
        }
    };
    
    const createCardElement = () => {
        const { stripe } = window;
        if (!stripe) {
            if (new Date().getTime() - then < 5000) {
                requestAnimationFrame(createCardElement);
            } else {
                reject('Stripe.js not found');
            }
            return;
        }
        const elements = stripe.elements(opts.elements || {});
        card = elements.create('card', {
            hidePostalCode: true,
            style: {
                base: {
                    fontSize: '16px',
                    color: '#733E5C',
                    fontSmoothing: 'antialiased',
                    ':-webkit-autofill': {
                        color: '#733E5C',
                    },
                    '::placeholder': {
                        color: '#733E5C',
                    },
                },
                invalid: {
                    iconColor: '#D61D64',
                    color: '#D61D64',
                }
            },
            ...(opts.card || {})
        });
        card.mount(`#${id}`);
        setFontsize();
        resolve(card);
    };

    createCardElement();
    Viewport.on('breakpoint', setFontsize);
});

export const createPaymentMethod = (card, billingDetails) => new Promise((resolve, reject) => {

    if (!card) {
        reject('Invalid card element');
    }

    const { stripe } = window;

    stripe
        .createPaymentMethod({
            type: 'card',
            billing_details: billingDetails,
            card
        })
        .then(({ error, paymentMethod }) => {
            if (error) {
                reject(error);
                return;
            }
            resolve(paymentMethod.id);
        })
        .catch(error => {
            reject(error);
        });

});

/**
 *
 * @param card
 * @param billingDetails
 * @returns {Promise<unknown>}
 */
export const confirmCardSetup = (card, billingDetails) => new Promise((resolve, reject) => {

    if (!card) {
        reject('Invalid card element');
        return;
    }

    getAxios()
        .post(Config.get('setupIntentSecretEndpoint'))
        .then(({ data }) => data)
        .then(({ secret: setupIntentSecret }) => {
            // Confirm the SetupIntent with the card details
            const { stripe } = window;
            stripe
                .confirmCardSetup(setupIntentSecret, {
                    payment_method: {
                        card,
                        billing_details: billingDetails,
                    }
                })
                .then(({ error, setupIntent }) => {
                    if (error) {
                        reject(error);
                        return;
                    }
                    resolve(setupIntent.payment_method);
                })
                .catch(error => {
                    reject(error);
                });
        })
        .catch(error => {
            reject(error);
        });

});
